import * as React from 'react'
import { MuiTextFieldFormik } from '@sales-center/components'
import { Field } from 'formik'
import { ActivityType } from '@user/features/Activity/ActivitiyTypes/typings'
import MenuItem from '@mui/material/MenuItem'

type Props = {
  activityTypes: ActivityType[]
}

export function TypeSelector(props: Props) {
  const { activityTypes } = props

  return (
    <Field
      required
      component={MuiTextFieldFormik}
      disabled={false}
      fullWidth
      label="Activity Type"
      margin="normal"
      name="activityTypeId"
      select
      size="small"
      inputProps={{ 'data-test-id': 'activityType' }}
    >
      {activityTypes.map((type) => (
        <MenuItem value={type.id} key={type.id}>
          {type.name}
        </MenuItem>
      ))}
    </Field>
  )
}
